module.exports = __webpack_public_path__ + "media/images/emblems/Rothenbrunnen_wappen-c62c2dcd0293078a0bb53324b41d203d.svg";